export const translations = {
  de: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      gallery: "Galerie",
      orders: "Meine Bestellungen",
      cart: "Warenkorb",
      linkChild: "Kind verknüpfen",
      admin: "Admin",
      classes: "Klassen",
      students: "Schüler",
      photos: "Fotos",
      users: "Benutzer",
      printFormats: "Druckformate",
      bundles: "Bundles",
      siteSettings: "Webseite",
      analytics: "Statistiken",
      abandonedCarts: "Abgebrochene Käufe",
      logout: "Abmelden"
    },
    
    // Landing Page
    landing: {
      tagline: "Professionelle Schulfotografie",
      heroTitle1: "Die Schulzeit",
      heroTitle2: "Ihres Kindes",
      heroTitle3: "Für Immer Festgehalten",
      heroDescription: "Durchstöbern, kaufen und laden Sie hochwertige Schulfotos ganz einfach herunter. Sichere Zugangskontrolle stellt sicher, dass Sie nur Fotos Ihrer eigenen Kinder sehen.",
      getStarted: "Jetzt Starten",
      signInEmail: "Mit E-Mail anmelden",
      goToDashboard: "Zum Dashboard",
      securePrivate: "Sicher & Privat",
      hdQuality: "HD Qualität",
      swissPayments: "Schweizer Zahlungen",
      accessAnytime: "Jederzeit Zugriff",
      whyParentsLove: "Warum Eltern uns lieben",
      whyParentsDesc: "Einfacher, sicherer und bequemer Zugang zu den Schulfotos Ihrer Kinder",
      featureSecure: "Sicherer Zugang",
      featureSecureDesc: "Jedes Kind hat einen eindeutigen Code. Eltern sehen nur die Fotos ihrer eigenen Kinder.",
      featureDownload: "Sofortige Downloads",
      featureDownloadDesc: "Kaufen Sie Fotos und laden Sie hochauflösende Originale sofort herunter.",
      featurePayment: "Einfache Zahlung",
      featurePaymentDesc: "Bezahlen Sie sicher mit Kreditkarte oder Twint. Schweizer Zahlungsmethoden unterstützt.",
      howItWorks: "So funktioniert's",
      howItWorksDesc: "Drei einfache Schritte zu Ihren Schulfotos",
      step1Title: "Code Erhalten",
      step1Desc: "Erhalten Sie einen eindeutigen Zugangscode von Ihrer Schule",
      step2Title: "Fotos Ansehen",
      step2Desc: "Sehen Sie sich Vorschaubilder mit Wasserzeichen an",
      step3Title: "Kaufen & Herunterladen",
      step3Desc: "Kaufen Sie die Fotos, die Sie lieben, und laden Sie sofort herunter",
      readyToView: "Bereit, Ihre Fotos anzusehen?",
      readyToViewDesc: "Melden Sie sich mit Ihrem Schulcode an, um auf die Fotos Ihres Kindes zuzugreifen",
      signInGoogle: "Mit Google anmelden"
    },
    
    // Auth
    auth: {
      welcomeBack: "Willkommen Zurück",
      signInAccess: "Melden Sie sich an, um auf Ihre Fotos zuzugreifen",
      continueGoogle: "Weiter mit Google",
      orContinueEmail: "Oder weiter mit E-Mail",
      emailLabel: "E-Mail",
      passwordLabel: "Passwort",
      signIn: "Anmelden",
      signingIn: "Anmeldung...",
      noAccount: "Noch kein Konto?",
      createAccount: "Konto erstellen",
      createAccountTitle: "Konto Erstellen",
      signUpAccess: "Registrieren Sie sich, um Schulfotos anzusehen und zu kaufen",
      orRegisterEmail: "Oder mit E-Mail registrieren",
      fullName: "Vollständiger Name",
      minChars: "Mindestens 6 Zeichen",
      creating: "Konto wird erstellt...",
      haveAccount: "Bereits ein Konto?",
      backToHome: "Zurück zur Startseite",
      welcomeBackToast: "Willkommen zurück!",
      loginFailed: "Anmeldung fehlgeschlagen",
      accountCreated: "Konto erfolgreich erstellt!",
      registrationFailed: "Registrierung fehlgeschlagen",
      invalidResponse: "Ungültige Authentifizierungs-Antwort",
      welcomeUser: "Willkommen, {name}!",
      authFailed: "Authentifizierung fehlgeschlagen. Bitte erneut versuchen."
    },
    
    // Dashboard
    dashboard: {
      adminTitle: "Admin Dashboard",
      adminDesc: "Klassen, Schüler und Fotos verwalten",
      teacherTitle: "Lehrer Dashboard",
      teacherDesc: "Klassenfotos ansehen",
      parentTitle: "Eltern Dashboard",
      parentDesc: "Fotos Ihrer Kinder ansehen und kaufen",
      classes: "Klassen",
      students: "Schüler",
      photos: "Fotos",
      orders: "Bestellungen",
      quickActions: "Schnellaktionen",
      teacherCodeTitle: "Lehrer-Code eingeben",
      teacherCodeDesc: "Geben Sie den Code Ihrer Klasse ein, um Zugang zu den Fotos zu erhalten",
      redeemCode: "Einlösen",
      teacherCodeSuccess: "Zugang gewährt für",
      teacherCodeInvalid: "Ungültiger Code",
      manageClasses: "Klassen verwalten",
      manageStudents: "Schüler verwalten",
      uploadPhotos: "Fotos hochladen",
      manageUsers: "Benutzer verwalten",
      viewGallery: "Galerie ansehen",
      myOrders: "Meine Bestellungen",
      linkChild: "Kind verknüpfen",
      recentPhotos: "Neueste Fotos",
      viewAll: "Alle ansehen",
      linkYourChild: "Kind verknüpfen",
      linkChildDesc: "Geben Sie den eindeutigen Code Ihres Kindes ein, um dessen Schulfotos zu sehen."
    },
    
    // Gallery
    gallery: {
      title: "Fotogalerie",
      description: "Durchstöbern und kaufen Sie Schulfotos",
      filterByClass: "Nach Klasse filtern",
      allClasses: "Alle Klassen",
      classPhotos: "Klassenfotos",
      individualPhotos: "Einzelfotos",
      noPhotos: "Keine Fotos Verfügbar",
      noPhotosParent: "Es sind noch keine Fotos für Ihr Kind verfügbar. Die Fotos werden in der Regel ca. 2 Wochen nach dem Fototag hochgeladen. Bitte schauen Sie später nochmals vorbei.",
      noPhotosOther: "Es sind noch keine Fotos verfügbar. Die Fotos werden in der Regel ca. 2 Wochen nach dem Fototag hochgeladen. Bitte schauen Sie später nochmals vorbei.",
      classPhoto: "Klassenfoto",
      addToCart: "Hinzufügen",
      inCart: "Im Warenkorb",
      downloadFree: "Gratis Download",
      free: "GRATIS",
      photoPreview: "Foto-Vorschau",
      daysLeft: "Nur noch {n} Tage",
      lastDay: "Letzter Tag!"
    },
    
    // Cart
    cart: {
      title: "Warenkorb",
      itemsInCart: "Artikel in Ihrem Warenkorb",
      item: "Artikel",
      items: "Artikel",
      emptyCart: "Ihr Warenkorb ist leer",
      emptyCartDesc: "Durchstöbern Sie die Galerie, um Fotos zu kaufen",
      browseGallery: "Galerie durchsuchen",
      clearCart: "Warenkorb leeren",
      orderSummary: "Bestellübersicht",
      subtotal: "Zwischensumme",
      tax: "MwSt.",
      total: "Gesamt",
      siblingDiscount: "Geschwister-Rabatt ({n} Kinder)",
      checkout: "Zur Kasse",
      processing: "Verarbeitung...",
      securePayment: "Sichere Zahlung über Stripe. Karte & Twint akzeptiert.",
      removeFromCart: "Aus Warenkorb entfernen"
    },
    
    // Checkout
    checkout: {
      processing: "Zahlung wird verarbeitet",
      pleaseWait: "Bitte warten Sie, während wir Ihre Zahlung bestätigen...",
      success: "Zahlung Erfolgreich!",
      thankYou: "Vielen Dank für Ihren Kauf. Ihre Fotos sind jetzt zum Download verfügbar.",
      amountPaid: "Bezahlter Betrag",
      status: "Status",
      viewDownloads: "Downloads ansehen",
      continueShopping: "Weiter einkaufen",
      failed: "Zahlung Fehlgeschlagen",
      failedDesc: "Wir konnten Ihre Zahlung nicht bestätigen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      tryAgain: "Erneut versuchen",
      backToDashboard: "Zurück zum Dashboard"
    },
    
    // Orders
    orders: {
      title: "Meine Bestellungen",
      description: "Anzeigen und Herunterladen Ihrer gekauften Fotos",
      noOrders: "Noch keine Bestellungen",
      noOrdersDesc: "Ihre gekauften Fotos werden hier angezeigt",
      paid: "Bezahlt",
      pending: "Ausstehend",
      cancelled: "Storniert",
      photo: "Foto",
      downloadPending: "Zahlung ausstehend. Fotos sind nach Zahlungsbestätigung verfügbar.",
      reconcileWithStripe: "Zahlung bei Stripe prüfen",
      reconciling: "Prüfe...",
      reconciledPaid: "Zahlung bei Stripe bestätigt – Bestellung als bezahlt markiert und Download-Link versendet.",
      reconciledAlreadyPaid: "Bestellung war bereits als bezahlt markiert.",
      reconciledStillUnpaid: "Stripe zeigt diese Bestellung noch nicht als bezahlt.",
      orderCancelled: "Diese Bestellung wurde storniert.",
      editOrder: "Bestellung bearbeiten",
      orderStatus: "Bestellstatus",
      printStatus: "Druckstatus",
      confirmDelete: "Bestellung löschen?",
      confirmDeleteDesc: "Möchten Sie diese Bestellung wirklich löschen:",
      downloadAll: "Alle herunterladen (ZIP)",
      preparingZip: "ZIP wird vorbereitet...",
      photosExpired: "Diese Fotos sind nicht mehr online.",
      photosExpiredDesc: "Bei Fragen kontaktieren Sie uns bitte:",
      adminPhotoDeletion: "Fotos werden automatisch gelöscht ab",
      adminPhotoDeletionHint: "Eltern frühzeitig erinnern"
    },
    
    // Link Student
    linkStudent: {
      title: "Kind verknüpfen",
      description: "Geben Sie den eindeutigen Code ein, den Sie von Ihrer Schule erhalten haben, um die Fotos Ihres Kindes zu sehen",
      studentCode: "Schülercode",
      placeholder: "z.B. SC1A2B3C4D",
      search: "Suchen",
      studentFound: "Schüler gefunden",
      name: "Name",
      code: "Code",
      linkThisChild: "Dieses Kind verknüpfen",
      linking: "Verknüpfung...",
      codeInfo: "Der Code sollte Ihnen von Ihrer Schule per Brief oder E-Mail zugesandt worden sein.",
      successTitle: "Erfolgreich verknüpft!",
      successDesc: "wurde mit Ihrem Konto verknüpft. Sie können jetzt die Fotos in der Galerie ansehen.",
      linkAnother: "Weiteres Kind verknüpfen",
      enterCode: "Bitte geben Sie einen Code ein",
      notFound: "Kein Schüler mit diesem Code gefunden",
      searchFailed: "Suche fehlgeschlagen",
      linkSuccess: "Kind erfolgreich verknüpft!",
      linkFailed: "Verknüpfung fehlgeschlagen"
    },
    
    // Admin
    admin: {
      teacherCode: "Lehrer-Code",
      isTeacherPhoto: "Lehrerfoto",
      teacherPriceNotice: "Lehrerfotos sind digital kostenlos. Der Preis wird auf 0 gesetzt. Druckbestellungen bleiben kostenpflichtig.",
      filterByStudent: "Nach Schüler filtern",
      allStudents: "Alle Schüler",
      teacherPhoto: "Lehrerfoto",
      manageClasses: "Klassen verwalten",
      manageClassesDesc: "Schulklassen erstellen und verwalten",
      addClass: "Klasse hinzufügen",
      createClass: "Klasse erstellen",
      editClass: "Klasse bearbeiten",
      className: "Klassenname",
      year: "Jahr",
      schoolName: "Schulname",
      updateClass: "Klasse aktualisieren",
      noClasses: "Noch keine Klassen",
      noClassesDesc: "Erstellen Sie Ihre erste Klasse, um loszulegen",
      classCreated: "Klasse erstellt",
      classUpdated: "Klasse aktualisiert",
      classDeleted: "Klasse gelöscht",
      classDeleteConfirm: "Möchten Sie diese Klasse wirklich löschen?",
      sendMessage: "Nachricht an Eltern senden",
      sendMessageTo: "Nachricht senden an",
      messageRequired: "Bitte Betreff und Nachricht ausfüllen",
      messageRecipients: "registrierte Eltern erhalten diese Nachricht",
      messageNoRecipients: "Keine registrierten Eltern in dieser Klasse",
      messageSubject: "Betreff",
      messageSubjectPlaceholder: "z.B. Neue Fotos sind verfügbar",
      messageBody: "Nachricht",
      messageBodyPlaceholder: "Schreiben Sie hier Ihre Nachricht an die Eltern...",
      messageSent: "E-Mails gesendet",
      sendNow: "Jetzt senden",
      
      manageStudents: "Schüler verwalten",
      manageStudentsDesc: "Schüler erstellen und ihre eindeutigen Codes verwalten",
      addStudent: "Schüler hinzufügen",
      createStudent: "Schüler erstellen",
      editStudent: "Schüler bearbeiten",
      studentName: "Schülername",
      selectClass: "Klasse auswählen",
      updateStudent: "Schüler aktualisieren",
      noStudents: "Noch keine Schüler",
      noStudentsDesc: "Fügen Sie Schüler hinzu, um eindeutige Codes für Eltern zu generieren",
      createClassFirst: "Erstellen Sie zuerst eine Klasse",
      createClassFirstDesc: "Sie müssen mindestens eine Klasse erstellen, bevor Sie Schüler hinzufügen können",
      
      managePhotos: "Fotos verwalten",
      managePhotosDesc: "Schulfotos hochladen und verwalten",
      uploadPhoto: "Foto hochladen",
      uploadPhotos: "Fotos hochladen",
      photosUploaded: "Foto(s) hochgeladen",
      bulkUpload: "Mehrere hochladen",
      selectPhoto: "Klicken Sie, um ein Foto auszuwählen",
      selectPhotos: "Klicken Sie, um Fotos auszuwählen",
      selectedFiles: "Dateien ausgewählt",
      class: "Klasse",
      isClassPhoto: "Dies ist ein Klassenfoto (sichtbar für alle Eltern in der Klasse)",
      selectStudents: "Schüler im Foto auswählen",
      assignToStudent: "Schüler zuweisen",
      selectStudent: "Schüler auswählen",
      editPhoto: "Foto bearbeiten",
      noStudentAssigned: "Kein Schüler zugewiesen",
      noStudentsInClass: "Keine Schüler in dieser Klasse",
      classPhoto: "Klassenfoto",
      price: "Preis (CHF)",
      uploading: "Wird hochgeladen...",
      noPhotos: "Noch keine Fotos",
      noPhotosDesc: "Laden Sie Ihr erstes Foto hoch, um loszulegen",
      createClassesFirst: "Erstellen Sie zuerst Klassen",
      createClassesFirstDesc: "Sie müssen Klassen erstellen, bevor Sie Fotos hochladen können",
      // Bulk actions
      bulkSelected: "ausgewählt",
      bulkSelectAll: "Alle auswählen",
      bulkClearSelection: "Auswahl löschen",
      bulkDelete: "Löschen",
      bulkReprice: "Preis ändern",
      bulkReassign: "Zuweisen",
      bulkDeleteConfirm: "Möchten Sie {n} Foto(s) wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      bulkDeleteSuccess: "{n} Foto(s) gelöscht",
      bulkRepriceDialogTitle: "Preis für ausgewählte Fotos ändern",
      bulkRepriceDialogDesc: "Neuer Preis (CHF) für {n} ausgewählte Foto(s).",
      bulkReassignDialogTitle: "Ausgewählte Fotos zuweisen",
      bulkReassignDialogDesc: "Ändern Sie die Zuweisung für {n} ausgewählte Foto(s).",
      bulkReassignAsClassPhoto: "Als Klassenfoto markieren",
      bulkReassignToStudent: "Einem Schüler zuweisen",
      bulkReassignClear: "Zuweisung entfernen",
      bulkUpdateSuccess: "{n} Foto(s) aktualisiert",
      bulkMultipleClassesWarning: "Mehrere Klassen ausgewählt – Schülerzuweisung deaktiviert.",
      bulkApply: "Anwenden",
      
      manageUsers: "Benutzer verwalten",
      manageUsersDesc: "Benutzerrollen anzeigen und verwalten",
      noUsers: "Noch keine Benutzer",
      noUsersDesc: "Benutzer werden hier angezeigt, wenn sie sich registrieren",
      you: "Sie",
      admin: "Admin",
      teacher: "Lehrer",
      parent: "Eltern"
    },
    

    // Users
    users: {
      title: "Benutzer verwalten",
      description: "Rollen zuweisen und Benutzer verwalten",
      noUsers: "Noch keine Benutzer",
      you: "Sie",
      cannotChangeOwnRole: "Sie können Ihre eigene Rolle nicht ändern",
      confirmDelete: "Benutzer löschen?",
      confirmDeleteDesc: "Möchten Sie diesen Benutzer wirklich löschen:",
      roleAdmin: "Admin",
      roleTeacher: "Lehrer",
      roleParent: "Eltern",
      searchPlaceholder: "Name oder E-Mail suchen…",
      filterRole: "Rolle",
      allRoles: "Alle Rollen",
      sortBy: "Sortieren",
      sortNewest: "Neueste zuerst",
      sortOldest: "Älteste zuerst",
      sortNameAZ: "Name (A→Z)",
      sortNameZA: "Name (Z→A)",
      sortEmail: "E-Mail (A→Z)",
      sortRole: "Rolle",
      resultsCount: "{n} von {total} Benutzern"
    },

    // Prints
    prints: {
      manageFormats: "Druckformate verwalten",
      manageFormatsDesc: "Print-Formate und Preise erstellen und verwalten",
      addFormat: "Format hinzufügen",
      createFormat: "Format erstellen",
      editFormat: "Format bearbeiten",
      formatName: "Formatname",
      formatDescription: "Beschreibung",
      descriptionPlaceholder: "z.B. Hochglanz-Fotopapier",
      formatNamePlaceholder: "z.B. 10x15 cm",
      isActive: "Aktiv",
      active: "Aktiv",
      inactive: "Inaktiv",
      noFormats: "Noch keine Formate",
      noFormatsDesc: "Erstellen Sie Ihr erstes Druckformat",
      formatCreated: "Format erstellt",
      formatUpdated: "Format aktualisiert",
      formatDeleted: "Format gelöscht",
      confirmDelete: "Möchten Sie dieses Format wirklich löschen?",
      fillRequired: "Bitte füllen Sie alle Pflichtfelder aus",
      orderPrint: "Print bestellen",
      selectFormat: "Format wählen",
      addPrint: "Print hinzufügen",
      printOrder: "Print-Bestellung",
      quantity: "Menge",
      shippingAddress: "Lieferadresse",
      name: "Name",
      street: "Strasse",
      city: "Ort",
      postalCode: "PLZ",
      country: "Land",
      shippingRequired: "Lieferadresse erforderlich für Print-Bestellungen",
      digitalDownload: "Digitaler Download",
      physicalPrint: "Druck",
      printItems: "Print-Artikel",
      digitalItems: "Digitale Artikel",
      printStatus: "Druckstatus",
      processing: "In Bearbeitung",
      shipped: "Versendet",
      delivered: "Geliefert",
      fillShipping: "Bitte füllen Sie die Lieferadresse aus"
    },

    // Bundles
    bundles: {
      title: "Foto-Bundles",
      manageBundles: "Bundles verwalten",
      manageBundlesDesc: "Erstellen und verwalten Sie Foto-Bundles mit Rabatt",
      addBundle: "Bundle hinzufügen",
      createBundle: "Bundle erstellen",
      editBundle: "Bundle bearbeiten",
      bundleName: "Bundle-Name",
      selectClass: "Klasse wählen",
      allClasses: "Alle Klassen (Global)",
      discountPercent: "Rabatt (%)",
      fixedPrice: "Festpreis",
      pricingMode: "Preisgestaltung",
      bundleNamePlaceholder: "z.B. Alle Klassenfotos",
      discountPlaceholder: "z.B. 20",
      fixedPricePlaceholder: "z.B. 49.00",
      noBundles: "Noch keine Bundles",
      noBundlesDesc: "Erstellen Sie Ihr erstes Foto-Bundle",
      bundleCreated: "Bundle erstellt",
      bundleUpdated: "Bundle aktualisiert",
      bundleDeleted: "Bundle gelöscht",
      confirmDelete: "Möchten Sie dieses Bundle wirklich löschen?",
      fillRequired: "Bitte füllen Sie alle Pflichtfelder aus",
      buyAllPhotos: "Alle Fotos kaufen",
      photosIncluded: "Fotos enthalten",
      originalPrice: "Originalpreis",
      discount: "Rabatt",
      youSave: "Sie sparen",
      bundlePrice: "Bundle-Preis",
      addBundleToCart: "Bundle in den Warenkorb",
      bundleInCart: "Bundle im Warenkorb",
      photoBundle: "Foto-Bundle",
      bundleDiscount: "Bundle-Rabatt"
    },

    // Students
    students: {
      title: "Schüler verwalten",
      description: "Schüler erstellen und Zugangscodes verwalten",
      addStudent: "Schüler hinzufügen",
      editStudent: "Schüler bearbeiten",
      createStudent: "Schüler erstellen",
      studentName: "Schülername",
      studentNamePlaceholder: "z.B. Max Müller",
      selectClass: "Klasse wählen",
      noStudents: "Noch keine Schüler",
      noStudentsDesc: "Fügen Sie Schüler hinzu, um Zugangscodes zu generieren",
      createClassFirst: "Erstellen Sie zuerst eine Klasse",
      createClassFirstDesc: "Sie müssen mindestens eine Klasse erstellen, bevor Sie Schüler hinzufügen können",
      codeCopied: "Code kopiert",
      studentCreated: "Schüler erstellt",
      studentUpdated: "Schüler aktualisiert",
      studentDeleted: "Schüler gelöscht",
      confirmDelete: "Möchten Sie diesen Schüler wirklich löschen?",
      importCsv: "CSV importieren",
      importCsvDesc: "Laden Sie eine CSV-Datei hoch, um mehrere Schüler auf einmal hinzuzufügen",
      csvFormat: "CSV-Format: Name (eine Spalte) oder Vorname, Nachname (zwei Spalten)",
      selectFile: "Datei auswählen",
      importing: "Importiere...",
      importSuccess: "Schüler importiert",
      importFailed: "Import fehlgeschlagen",
      printCodes: "Codes drucken",
      printCodesDesc: "Druckbare Karten mit Zugangscodes für alle Schüler",
      codeCard: "Zugangskarte",
      scanOrVisit: "Besuchen Sie unsere Website und geben Sie diesen Code ein:",
      yourCode: "Dein Zugangscode",
      noClassSelected: "Wählen Sie eine Klasse, um Codes zu drucken",
      printPage: "Seite drucken",
      teacherCardTitle: "Lehrkraft-Code",
      teacherCardSubtitle: "Für Klassen-Lehrperson",
      teacherCardCode: "Lehrer-Zugangscode"
    },

    // Site Settings
    siteSettings: {
      title: "Webseite anpassen",
      description: "Passen Sie Texte, Logo und Bilder der Landingpage an",
      logo: "Logo",
      uploadLogo: "Logo hochladen",
      logoHint: "Empfohlen: Quadratisch, max. 200x200px",
      heroImage: "Hintergrundbild",
      uploadHero: "Bild hochladen",
      heroHint: "Empfohlen: 1920x1080px, Querformat",
      siteName: "Seitenname",
      siteNameHint: "Wird im Header und Footer angezeigt",
      heroSection: "Hero-Bereich",
      heroTitle1: "Titel Zeile 1",
      heroTitle2: "Titel Zeile 2 (farbig)",
      heroTitle3: "Titel Zeile 3",
      heroDescription: "Beschreibung",
      featuresSection: "Funktionen",
      feature: "Funktion",
      featureTitle: "Titel",
      featureDesc: "Beschreibung",
      stepsSection: "So funktioniert's",
      step: "Schritt",
      stepTitle: "Titel",
      stepDesc: "Beschreibung",
      ctaSection: "Handlungsaufruf (CTA)",
      ctaTitle: "Titel",
      ctaDescription: "Beschreibung",
      saved: "Einstellungen gespeichert",
      logoUploaded: "Logo hochgeladen",
      heroUploaded: "Hintergrundbild hochgeladen",
      leaveEmpty: "Leer lassen = Standard-Übersetzung verwenden",
      currentLogo: "Aktuelles Logo",
      currentHero: "Aktuelles Bild",
      removeLogo: "Logo entfernen",
      logoRemoved: "Logo entfernt",
      themeColors: "Farben & Theme",
      themeColorsHint: "Leere Felder verwenden die Standard-Farben. Änderungen werden nach dem Speichern sofort angewendet.",
      colorPrimary: "Akzentfarbe",
      colorPrimaryText: "Text auf Akzent",
      colorBackground: "Hintergrund",
      colorText: "Textfarbe",
      colorCard: "Karten-Hintergrund",
      colorCardText: "Karten-Text",
      colorSecondary: "Sekundär",
      colorMuted: "Gedämpft",
      colorMutedText: "Gedämpfter Text",
      colorBorder: "Rahmenfarbe",
      fonts: "Schriftarten",
      fontBody: "Text-Schriftart",
      fontHeading: "Überschriften-Schriftart",
      analytics: "Google Analytics",
      analyticsHint: "Tracking wird nur aktiviert, wenn ein Besucher der Cookie-Nutzung zustimmt (DSGVO-konform).",
      gaId: "Mess-ID",
      gaIdHint: "Google Analytics Mess-ID, z.B. G-XXXXXXXXXX. Leer lassen um Tracking zu deaktivieren.",
      pricing: "Preisgestaltung",
      pricingHint: "Rabatte und Preisregeln für den Shop.",
      siblingDiscountPercent: "Geschwister-Rabatt (%)",
      siblingDiscountHint: "Wird automatisch auf digitale Fotos & Prints angewendet, wenn Eltern Fotos von 2+ Kindern im Warenkorb haben. Bundles bleiben unverändert.",
      defaultPhotoPrice: "Standardpreis pro Foto",
      defaultPhotoPriceHint: "Voreingestellter Preis im Upload-Fenster. Kann pro Upload überschrieben werden.",
      photoRetentionDays: "Aufbewahrungsdauer Fotos",
      photoRetentionDaysHint: "Anzahl Tage bis Fotos automatisch gelöscht werden. Änderungen gelten rückwirkend auch für bereits hochgeladene Fotos. Muss grösser als 10 sein (Reserve für die Löschungs-Erinnerung).",
      days: "Tage",
      aboutMe: "Über mich",
      aboutPhoto: "Profilbild",
      aboutPhotoHint: "Wird auf der Über-mich-Seite angezeigt.",
      aboutBio: "Biografie",
      aboutBioPlaceholder: "Erzählen Sie den Eltern etwas über sich und Ihre Arbeit...",
      preview: "Vorschau",
      previewPrintEmail: "Print-E-Mail Vorschau",
      fontDefault: "Standard"
    },

    // Common
    common: {
      loading: "Laden...",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
      create: "Erstellen",
      update: "Aktualisieren",
      close: "Schliessen",
      download: "Herunterladen",
      upload: "Hochladen",
      search: "Suchen",
      filter: "Filtern",
      all: "Alle",
      yes: "Ja",
      no: "Nein",
      sending: "Senden...",
      more: "weitere",
      confirm: "Bestätigen",
      back: "Zurück",
      next: "Weiter",
      previous: "Zurück",
      copied: "Kopiert",
      error: "Fehler",
      success: "Erfolg",
      loadFailed: "Laden fehlgeschlagen",
      saveFailed: "Speichern fehlgeschlagen",
      deleteFailed: "Löschen fehlgeschlagen",
      photoAlt: "Foto"
    },

    // Cookies
    cookies: {
      title: "Cookie-Einstellungen",
      description: "Wir verwenden Cookies zur Analyse der Webseitennutzung. Ihre Daten werden nur mit Ihrer Zustimmung erhoben. Mehr dazu in unserer",
      privacyLink: "Datenschutzerklärung",
      accept: "Akzeptieren",
      decline: "Ablehnen"
    },

    // Analytics
    analytics: {
      title: "Statistiken",
      description: "Umsatz, Bestellungen und Nutzerdaten auf einen Blick",
      totalRevenue: "Gesamtumsatz",
      paidOrders: "Bezahlte Bestellungen",
      totalUsers: "Benutzer",
      nonBuyers: "Nicht-Käufer",
      nonBuyersSub: "Eltern ohne bezahlte Bestellung",
      totalPhotos: "Fotos",
      revenueOverTime: "Umsatz über Zeit",
      ordersOverTime: "Bestellungen über Zeit",
      revenueBreakdown: "Umsatz nach Typ",
      revenue: "Umsatz",
      orders: "Bestellungen",
      digital: "Digital",
      prints: "Drucke",
      bundles: "Bundles",
      userRoles: "Benutzerrollen",
      topPhotos: "Meistverkaufte Fotos",
      purchases: "Käufe",
      recentOrders: "Letzte Bestellungen",
      orderId: "Bestellnr.",
      customer: "Kunde",
      amount: "Betrag",
      date: "Datum",
      pending: "ausstehend",
      noData: "Noch keine Daten vorhanden",
      retentionTitle: "Aufbewahrungs-Erinnerungen",
      retentionDesc: "Senden Sie Eltern eine Erinnerung, wenn ihre Fotos in 10 Tagen gelöscht werden.",
      retentionExpiring: "Bald abläufig",
      retentionOrders: "Bestellungen",
      retentionUsers: "Benutzer",
      retentionSendButton: "Erinnerungen senden",
      retentionSending: "Senden...",
      retentionEmailsSent: "E-Mails gesendet",
      retentionNoneAffected: "Derzeit keine Fotos, die demnächst ablaufen.",
      nudgeTitle: "Kaufanreiz für Nicht-Käufer",
      nudgeDesc: "Erinnern Sie registrierte Eltern ohne Bestellung, dass die Fotos ihres Kindes bald gelöscht werden.",
      nudgeOutstanding: "Ausstehend",
      nudgeAlreadyReminded: "Bereits erinnert",
      nudgeEligibleTotal: "Total berechtigt",
      nudgeDiagnostics: "{photos} Fotos im Zielfenster (Alter {min}–{max} Tage · Aufbewahrung {retention} Tage). Falls 0: kein Foto im Bereich, oder alle betroffenen Eltern haben schon bezahlt/wurden bereits erinnert.",
      nudgeDaysBeforeLabel: "Tage vor Löschung:",
      nudgeSendButton: "Nudge senden",
      nudgeSending: "Senden...",
      nudgeQueued: "E-Mails in die Warteschlange gestellt",
      nudgeNoneOutstanding: "Aktuell keine ausstehenden Eltern zu erinnern.",
      buyerBehaviorTitle: "Käuferverhalten",
      buyerBehaviorDesc: "Verteilung der bezahlten Bestellungen nach Produktart",
      bundleBuyersLabel: "Bundle-Käufer",
      printBuyersLabel: "Print-Käufer",
      digitalOnlyBuyersLabel: "Nur digital",
      alacarteDigitalLabel: "Einzeln gekaufte Fotos",
      alacarteDigitalSub: "Digitale Fotos ohne Bundle",
      reminderStatsTitle: "Warenkorb-Wiederherstellung",
      parentEngagementTitle: "Eltern-Engagement",
      parentEngagementDesc: "Wie viele Eltern kaufen Fotos und für wie viele ihrer Kinder.",
      purchaseRate: "Kaufquote",
      parentsLowercase: "Eltern",
      ordersPerParent: "Ø Bestellungen / Eltern",
      ordersPerParentSub: "Gesamt-Durchschnitt",
      ordersPerActiveParent: "Ø Bestellungen / Käufer",
      ordersPerActiveParentSub: "Nur Eltern mit Käufen",
      childrenPerActiveParent: "Ø Kinder / Käufer",
      childrenPerActiveParentSub: "Verschiedene Kinder pro kaufendem Elternteil",
      reminderStatsDesc: "Wie viele Erinnerungs-E-Mails zu echten Käufen geführt haben (14-Tage-Fenster)",
      remindersSent: "Erinnerungen gesendet",
      remindersRecovered: "Käufe wiederhergestellt",
      recoveryRate: "Wiederherstellungsrate",
      recoveredRevenue: "Wiederhergestellter Umsatz",
      openCarts: "Offene Warenkörbe",
      role_admin: "Admin",
      role_teacher: "Lehrer",
      role_parent: "Eltern",
      periodLabel: "Zeitraum",
      schoolLabel: "Schule",
      classLabel: "Klasse",
      allSchools: "Alle Schulen",
      allClasses: "Alle Klassen",
      period_all: "Gesamt",
      period_month: "Aktueller Monat",
      period_3months: "Letzte 3 Monate",
      period_6months: "Letzte 6 Monate",
      period_year: "Aktuelles Jahr",
      period_last_year: "Letztes Jahr"
    },

    // Abandoned carts
    abandonedCarts: {
      title: "Abgebrochene Käufe",
      description: "Nutzer, die Artikel im Warenkorb gelassen haben.",
      olderThan: "Älter als",
      h1: "1 Stunde",
      h6: "6 Stunden",
      h24: "24 Stunden",
      h72: "3 Tage",
      h168: "7 Tage",
      empty: "Keine abgebrochenen Käufe",
      emptyDesc: "Alle Nutzer haben ihre Bestellungen abgeschlossen.",
      items: "Artikel",
      total: "Gesamt",
      sendReminder: "Erinnerung senden",
      reminderSent: "Erinnerung gesendet",
      reminded: "Erinnert",
      minutesAgo: "vor {n} Min.",
      hoursAgo: "vor {n} Std.",
      daysAgo: "vor {n} Tagen"
    },

    // About
    about: {
      title: "Über mich",
      noBio: "Noch keine Beschreibung vorhanden."
    },

    // Contact form
    contact: {
      help: "Hilfe?",
      title: "Kontakt",
      description: "Schreiben Sie uns. Wir antworten meist innerhalb von 24 Stunden.",
      category: "Kategorie",
      cat_general: "Allgemein",
      cat_order: "Bestellung",
      cat_missing_photo: "Foto fehlt",
      cat_payment: "Zahlung",
      cat_technical: "Technisches Problem",
      cat_other: "Sonstiges",
      subject: "Betreff",
      subjectPlaceholder: "Kurz und prägnant",
      message: "Nachricht",
      messagePlaceholder: "Beschreiben Sie Ihr Anliegen...",
      send: "Senden",
      cancel: "Abbrechen",
      successToast: "Nachricht gesendet! Wir melden uns bald.",
      errorToast: "Senden fehlgeschlagen",
      rateLimitToast: "Zu viele Nachrichten. Bitte später erneut versuchen.",
      respondNote: "Wir antworten an Ihre E-Mail-Adresse:"
    }
  },
  
  en: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      gallery: "Gallery",
      orders: "My Orders",
      cart: "Cart",
      linkChild: "Link Child",
      admin: "Admin",
      classes: "Classes",
      students: "Students",
      photos: "Photos",
      users: "Users",
      printFormats: "Print Formats",
      bundles: "Bundles",
      siteSettings: "Website",
      analytics: "Analytics",
      abandonedCarts: "Abandoned Carts",
      logout: "Logout"
    },
    
    // Landing Page
    landing: {
      tagline: "Professional School Photography",
      heroTitle1: "Your Child's",
      heroTitle2: "School Memories",
      heroTitle3: "Captured Forever",
      heroDescription: "Browse, purchase, and download high-quality school photos with ease. Secure access ensures you only see photos of your own children.",
      getStarted: "Get Started",
      signInEmail: "Sign In with Email",
      goToDashboard: "Go to Dashboard",
      securePrivate: "Secure & Private",
      hdQuality: "HD Quality",
      swissPayments: "Swiss Payments",
      accessAnytime: "Access Anytime",
      whyParentsLove: "Why Parents Love Us",
      whyParentsDesc: "Simple, secure, and convenient way to access your children's school photos",
      featureSecure: "Secure Access",
      featureSecureDesc: "Each child has a unique code. Parents only see their own children's photos.",
      featureDownload: "Instant Downloads",
      featureDownloadDesc: "Purchase photos and download high-resolution originals immediately.",
      featurePayment: "Easy Payment",
      featurePaymentDesc: "Pay securely with credit card or Twint. Swiss payment methods supported.",
      howItWorks: "How It Works",
      howItWorksDesc: "Three simple steps to get your school photos",
      step1Title: "Get Your Code",
      step1Desc: "Receive a unique access code from your school",
      step2Title: "Browse Photos",
      step2Desc: "View watermarked previews of your child's photos",
      step3Title: "Purchase & Download",
      step3Desc: "Buy the photos you love and download instantly",
      readyToView: "Ready to View Your Photos?",
      readyToViewDesc: "Sign in with your school-provided code to access your child's photos",
      signInGoogle: "Sign In with Google"
    },
    
    // Auth
    auth: {
      welcomeBack: "Welcome Back",
      signInAccess: "Sign in to access your photos",
      continueGoogle: "Continue with Google",
      orContinueEmail: "Or continue with email",
      emailLabel: "Email",
      passwordLabel: "Password",
      signIn: "Sign In",
      signingIn: "Signing in...",
      noAccount: "Don't have an account?",
      createAccount: "Create account",
      createAccountTitle: "Create Account",
      signUpAccess: "Sign up to view and purchase school photos",
      orRegisterEmail: "Or register with email",
      fullName: "Full Name",
      minChars: "Minimum 6 characters",
      creating: "Creating account...",
      haveAccount: "Already have an account?",
      backToHome: "Back to home",
      welcomeBackToast: "Welcome back!",
      loginFailed: "Login failed",
      accountCreated: "Account created successfully!",
      registrationFailed: "Registration failed",
      invalidResponse: "Invalid authentication response",
      welcomeUser: "Welcome, {name}!",
      authFailed: "Authentication failed. Please try again."
    },
    
    // Dashboard
    dashboard: {
      adminTitle: "Admin Dashboard",
      adminDesc: "Manage classes, students, and photos",
      teacherTitle: "Teacher Dashboard",
      teacherDesc: "View your class photos",
      parentTitle: "Parent Dashboard",
      parentDesc: "View and purchase your children's photos",
      classes: "Classes",
      students: "Students",
      photos: "Photos",
      orders: "Orders",
      quickActions: "Quick Actions",
      teacherCodeTitle: "Enter Teacher Code",
      teacherCodeDesc: "Enter your class code to get access to the photos",
      redeemCode: "Redeem",
      teacherCodeSuccess: "Access granted for",
      teacherCodeInvalid: "Invalid code",
      manageClasses: "Manage Classes",
      manageStudents: "Manage Students",
      uploadPhotos: "Upload Photos",
      manageUsers: "Manage Users",
      viewGallery: "View Gallery",
      myOrders: "My Orders",
      linkChild: "Link Child",
      recentPhotos: "Recent Photos",
      viewAll: "View All",
      linkYourChild: "Link Your Child",
      linkChildDesc: "Enter your child's unique code to see their school photos."
    },
    
    // Gallery
    gallery: {
      title: "Photo Gallery",
      description: "Browse and purchase school photos",
      filterByClass: "Filter by class",
      allClasses: "All Classes",
      classPhotos: "Class Photos",
      individualPhotos: "Individual Photos",
      noPhotos: "No Photos Available",
      noPhotosParent: "No photos are available for your child yet. Photos are usually uploaded about 2 weeks after the shooting day. Please check back later.",
      noPhotosOther: "No photos are available yet. Photos are usually uploaded about 2 weeks after the shooting day. Please check back later.",
      classPhoto: "Class Photo",
      addToCart: "Add",
      inCart: "In Cart",
      downloadFree: "Download Free",
      free: "FREE",
      photoPreview: "Photo Preview",
      daysLeft: "Only {n} days left",
      lastDay: "Last day!"
    },
    
    // Cart
    cart: {
      title: "Shopping Cart",
      itemsInCart: "items in your cart",
      item: "item",
      items: "items",
      emptyCart: "Your cart is empty",
      emptyCartDesc: "Browse the gallery to find photos to purchase",
      browseGallery: "Browse Gallery",
      clearCart: "Clear Cart",
      orderSummary: "Order Summary",
      subtotal: "Subtotal",
      tax: "Tax",
      total: "Total",
      siblingDiscount: "Sibling discount ({n} children)",
      checkout: "Checkout",
      processing: "Processing...",
      securePayment: "Secure payment via Stripe. Card & Twint accepted.",
      removeFromCart: "Remove from cart"
    },
    
    // Checkout
    checkout: {
      processing: "Processing Payment",
      pleaseWait: "Please wait while we confirm your payment...",
      success: "Payment Successful!",
      thankYou: "Thank you for your purchase. Your photos are now available for download.",
      amountPaid: "Amount Paid",
      status: "Status",
      viewDownloads: "View Downloads",
      continueShopping: "Continue Shopping",
      failed: "Payment Failed",
      failedDesc: "We couldn't confirm your payment. Please try again or contact support.",
      tryAgain: "Try Again",
      backToDashboard: "Back to Dashboard"
    },
    
    // Orders
    orders: {
      title: "My Orders",
      description: "View and download your purchased photos",
      noOrders: "No orders yet",
      noOrdersDesc: "Your purchased photos will appear here",
      paid: "Paid",
      pending: "Pending",
      cancelled: "Cancelled",
      photo: "photo",
      downloadPending: "Payment pending. Photos will be available after payment is confirmed.",
      reconcileWithStripe: "Check payment on Stripe",
      reconciling: "Checking...",
      reconciledPaid: "Payment confirmed on Stripe — order marked paid and download link sent.",
      reconciledAlreadyPaid: "Order was already marked paid.",
      reconciledStillUnpaid: "Stripe does not show this order as paid yet.",
      orderCancelled: "This order was cancelled.",
      editOrder: "Edit Order",
      orderStatus: "Order Status",
      printStatus: "Print Status",
      confirmDelete: "Delete Order?",
      confirmDeleteDesc: "Are you sure you want to delete order:",
      downloadAll: "Download All (ZIP)",
      preparingZip: "Preparing ZIP...",
      photosExpired: "These photos are no longer online.",
      photosExpiredDesc: "Please contact us if you have any questions:",
      adminPhotoDeletion: "Photos auto-delete from",
      adminPhotoDeletionHint: "Remind parents in advance"
    },
    
    // Link Student
    linkStudent: {
      title: "Link Your Child",
      description: "Enter the unique code provided by your school to see your child's photos",
      studentCode: "Student Code",
      placeholder: "e.g., SC1A2B3C4D",
      search: "Search",
      studentFound: "Student Found",
      name: "Name",
      code: "Code",
      linkThisChild: "Link This Child",
      linking: "Linking...",
      codeInfo: "The code should have been provided by your school via letter or email.",
      successTitle: "Successfully Linked!",
      successDesc: "has been linked to your account. You can now view their photos in the gallery.",
      linkAnother: "Link Another Child",
      enterCode: "Please enter a code",
      notFound: "No student found with this code",
      searchFailed: "Search failed",
      linkSuccess: "Child linked successfully!",
      linkFailed: "Failed to link child"
    },
    
    // Admin
    admin: {
      teacherCode: "Teacher Code",
      isTeacherPhoto: "Teacher Photo",
      teacherPriceNotice: "Teacher photos are free as digital downloads. The price is set to 0. Print orders remain paid.",
      filterByStudent: "Filter by student",
      allStudents: "All students",
      teacherPhoto: "Teacher Photo",
      manageClasses: "Manage Classes",
      manageClassesDesc: "Create and manage school classes",
      addClass: "Add Class",
      createClass: "Create Class",
      editClass: "Edit Class",
      className: "Class Name",
      year: "Year",
      schoolName: "School Name",
      updateClass: "Update Class",
      noClasses: "No classes yet",
      noClassesDesc: "Create your first class to get started",
      classCreated: "Class created",
      classUpdated: "Class updated",
      classDeleted: "Class deleted",
      classDeleteConfirm: "Are you sure you want to delete this class?",
      sendMessage: "Send message to parents",
      sendMessageTo: "Send message to",
      messageRequired: "Subject and message are required",
      messageRecipients: "registered parents will receive this message",
      messageNoRecipients: "No registered parents in this class",
      messageSubject: "Subject",
      messageSubjectPlaceholder: "e.g. New photos are now available",
      messageBody: "Message",
      messageBodyPlaceholder: "Write your message to the parents here...",
      messageSent: "emails sent",
      sendNow: "Send Now",
      
      manageStudents: "Manage Students",
      manageStudentsDesc: "Create students and manage their unique codes",
      addStudent: "Add Student",
      createStudent: "Create Student",
      editStudent: "Edit Student",
      studentName: "Student Name",
      selectClass: "Select a class",
      updateStudent: "Update Student",
      noStudents: "No students yet",
      noStudentsDesc: "Add students to generate unique codes for parents",
      createClassFirst: "Create a class first",
      createClassFirstDesc: "You need to create at least one class before adding students",
      
      managePhotos: "Manage Photos",
      managePhotosDesc: "Upload and manage school photos",
      uploadPhoto: "Upload Photo",
      uploadPhotos: "Upload Photos",
      photosUploaded: "photo(s) uploaded",
      bulkUpload: "Bulk Upload",
      selectPhoto: "Click to select a photo",
      selectPhotos: "Click to select photos",
      selectedFiles: "files selected",
      class: "Class",
      isClassPhoto: "This is a class photo (visible to all parents in the class)",
      selectStudents: "Select Students in Photo",
      assignToStudent: "Assign to Student",
      selectStudent: "Select student",
      editPhoto: "Edit Photo",
      noStudentAssigned: "No student assigned",
      noStudentsInClass: "No students in this class",
      classPhoto: "Class Photo",
      price: "Price (CHF)",
      uploading: "Uploading...",
      noPhotos: "No photos yet",
      noPhotosDesc: "Upload your first photo to get started",
      createClassesFirst: "Create classes first",
      createClassesFirstDesc: "You need to create classes before uploading photos",
      // Bulk actions
      bulkSelected: "selected",
      bulkSelectAll: "Select all",
      bulkClearSelection: "Clear selection",
      bulkDelete: "Delete",
      bulkReprice: "Reprice",
      bulkReassign: "Reassign",
      bulkDeleteConfirm: "Are you sure you want to delete {n} photo(s)? This cannot be undone.",
      bulkDeleteSuccess: "{n} photo(s) deleted",
      bulkRepriceDialogTitle: "Reprice selected photos",
      bulkRepriceDialogDesc: "New price (CHF) for {n} selected photo(s).",
      bulkReassignDialogTitle: "Reassign selected photos",
      bulkReassignDialogDesc: "Change the assignment for {n} selected photo(s).",
      bulkReassignAsClassPhoto: "Mark as class photo",
      bulkReassignToStudent: "Assign to a student",
      bulkReassignClear: "Clear assignment",
      bulkUpdateSuccess: "{n} photo(s) updated",
      bulkMultipleClassesWarning: "Multiple classes selected — student assignment disabled.",
      bulkApply: "Apply",
      
      manageUsers: "Manage Users",
      manageUsersDesc: "View and manage user roles",
      noUsers: "No users yet",
      noUsersDesc: "Users will appear here when they register",
      you: "You",
      admin: "Admin",
      teacher: "Teacher",
      parent: "Parent"
    },
    

    // Users
    users: {
      title: "Manage Users",
      description: "Assign roles and manage users",
      noUsers: "No users yet",
      you: "You",
      cannotChangeOwnRole: "You cannot change your own role",
      confirmDelete: "Delete User?",
      confirmDeleteDesc: "Are you sure you want to delete:",
      roleAdmin: "Admin",
      roleTeacher: "Teacher",
      roleParent: "Parent",
      searchPlaceholder: "Search name or email…",
      filterRole: "Role",
      allRoles: "All roles",
      sortBy: "Sort",
      sortNewest: "Newest first",
      sortOldest: "Oldest first",
      sortNameAZ: "Name (A→Z)",
      sortNameZA: "Name (Z→A)",
      sortEmail: "Email (A→Z)",
      sortRole: "Role",
      resultsCount: "{n} of {total} users"
    },

    // Prints
    prints: {
      manageFormats: "Manage Print Formats",
      manageFormatsDesc: "Create and manage print formats and prices",
      addFormat: "Add Format",
      createFormat: "Create Format",
      editFormat: "Edit Format",
      formatName: "Format Name",
      formatDescription: "Description",
      descriptionPlaceholder: "e.g., Glossy photo paper",
      formatNamePlaceholder: "e.g., 10x15 cm",
      isActive: "Active",
      active: "Active",
      inactive: "Inactive",
      noFormats: "No formats yet",
      noFormatsDesc: "Create your first print format",
      formatCreated: "Format created",
      formatUpdated: "Format updated",
      formatDeleted: "Format deleted",
      confirmDelete: "Are you sure you want to delete this format?",
      fillRequired: "Please fill in all required fields",
      orderPrint: "Order Print",
      selectFormat: "Select format",
      addPrint: "Add Print",
      printOrder: "Print Order",
      quantity: "Quantity",
      shippingAddress: "Shipping Address",
      name: "Name",
      street: "Street",
      city: "City",
      postalCode: "Postal Code",
      country: "Country",
      shippingRequired: "Shipping address required for print orders",
      digitalDownload: "Digital Download",
      physicalPrint: "Print",
      printItems: "Print Items",
      digitalItems: "Digital Items",
      printStatus: "Print Status",
      processing: "Processing",
      shipped: "Shipped",
      delivered: "Delivered",
      fillShipping: "Please fill in the shipping address"
    },

    // Bundles
    bundles: {
      title: "Photo Bundles",
      manageBundles: "Manage Bundles",
      manageBundlesDesc: "Create and manage photo bundles with discounts",
      addBundle: "Add Bundle",
      createBundle: "Create Bundle",
      editBundle: "Edit Bundle",
      bundleName: "Bundle Name",
      selectClass: "Select Class",
      allClasses: "All Classes (Global)",
      discountPercent: "Discount (%)",
      fixedPrice: "Fixed Price",
      pricingMode: "Pricing Mode",
      bundleNamePlaceholder: "e.g., All Class Photos",
      discountPlaceholder: "e.g., 20",
      fixedPricePlaceholder: "e.g., 49.00",
      noBundles: "No bundles yet",
      noBundlesDesc: "Create your first photo bundle",
      bundleCreated: "Bundle created",
      bundleUpdated: "Bundle updated",
      bundleDeleted: "Bundle deleted",
      confirmDelete: "Are you sure you want to delete this bundle?",
      fillRequired: "Please fill in all required fields",
      buyAllPhotos: "Buy All Photos",
      photosIncluded: "photos included",
      originalPrice: "Original price",
      discount: "Discount",
      youSave: "You save",
      bundlePrice: "Bundle price",
      addBundleToCart: "Add bundle to cart",
      bundleInCart: "Bundle in cart",
      photoBundle: "Photo Bundle",
      bundleDiscount: "Bundle discount"
    },

    // Students
    students: {
      title: "Manage Students",
      description: "Create students and manage their access codes",
      addStudent: "Add Student",
      editStudent: "Edit Student",
      createStudent: "Create Student",
      studentName: "Student Name",
      studentNamePlaceholder: "e.g., John Smith",
      selectClass: "Select Class",
      noStudents: "No students yet",
      noStudentsDesc: "Add students to generate access codes for parents",
      createClassFirst: "Create a class first",
      createClassFirstDesc: "You need to create at least one class before adding students",
      codeCopied: "Code copied",
      studentCreated: "Student created",
      studentUpdated: "Student updated",
      studentDeleted: "Student deleted",
      confirmDelete: "Are you sure you want to delete this student?",
      importCsv: "Import CSV",
      importCsvDesc: "Upload a CSV file to add multiple students at once",
      csvFormat: "CSV format: Name (one column) or First Name, Last Name (two columns)",
      selectFile: "Select file",
      importing: "Importing...",
      importSuccess: "Students imported",
      importFailed: "Import failed",
      printCodes: "Print Codes",
      printCodesDesc: "Printable cards with access codes for all students",
      codeCard: "Access Card",
      scanOrVisit: "Visit our website and enter this code:",
      yourCode: "Your access code",
      noClassSelected: "Select a class to print codes",
      printPage: "Print page",
      teacherCardTitle: "Teacher Code",
      teacherCardSubtitle: "For the class teacher",
      teacherCardCode: "Teacher access code"
    },

    // Site Settings
    siteSettings: {
      title: "Customize Website",
      description: "Customize texts, logo and images on the landing page",
      logo: "Logo",
      uploadLogo: "Upload Logo",
      logoHint: "Recommended: Square, max 200x200px",
      heroImage: "Background Image",
      uploadHero: "Upload Image",
      heroHint: "Recommended: 1920x1080px, landscape",
      siteName: "Site Name",
      siteNameHint: "Shown in header and footer",
      heroSection: "Hero Section",
      heroTitle1: "Title Line 1",
      heroTitle2: "Title Line 2 (colored)",
      heroTitle3: "Title Line 3",
      heroDescription: "Description",
      featuresSection: "Features",
      feature: "Feature",
      featureTitle: "Title",
      featureDesc: "Description",
      stepsSection: "How It Works",
      step: "Step",
      stepTitle: "Title",
      stepDesc: "Description",
      ctaSection: "Call to Action (CTA)",
      ctaTitle: "Title",
      ctaDescription: "Description",
      saved: "Settings saved",
      logoUploaded: "Logo uploaded",
      heroUploaded: "Background image uploaded",
      leaveEmpty: "Leave empty = use default translation",
      currentLogo: "Current logo",
      currentHero: "Current image",
      removeLogo: "Remove logo",
      logoRemoved: "Logo removed",
      themeColors: "Colors & Theme",
      themeColorsHint: "Leave empty to use default colors. Changes apply immediately after saving.",
      colorPrimary: "Accent Color",
      colorPrimaryText: "Text on Accent",
      colorBackground: "Background",
      colorText: "Text Color",
      colorCard: "Card Background",
      colorCardText: "Card Text",
      colorSecondary: "Secondary",
      colorMuted: "Muted",
      colorMutedText: "Muted Text",
      colorBorder: "Border Color",
      fonts: "Fonts",
      fontBody: "Body Font",
      fontHeading: "Heading Font",
      analytics: "Google Analytics",
      analyticsHint: "Tracking is only activated when a visitor consents to cookies (GDPR-compliant).",
      gaId: "Measurement ID",
      gaIdHint: "Google Analytics Measurement ID, e.g. G-XXXXXXXXXX. Leave empty to disable tracking.",
      pricing: "Pricing",
      pricingHint: "Discounts and pricing rules for the shop.",
      siblingDiscountPercent: "Sibling discount (%)",
      siblingDiscountHint: "Automatically applied to digital photos & prints when parents have photos of 2+ children in their cart. Bundles are not affected.",
      defaultPhotoPrice: "Default photo price",
      defaultPhotoPriceHint: "Pre-filled price in the upload window. Can be overridden per upload.",
      photoRetentionDays: "Photo retention (days)",
      photoRetentionDaysHint: "How many days before photos are auto-deleted. Changes apply retroactively to already-uploaded photos. Must be greater than 10 (reserved for the pre-deletion reminder).",
      days: "days",
      aboutMe: "About Me",
      aboutPhoto: "Profile Photo",
      aboutPhotoHint: "Displayed on the About Me page.",
      aboutBio: "Bio",
      aboutBioPlaceholder: "Tell the parents a bit about yourself and your work...",
      preview: "Preview",
      previewPrintEmail: "Preview Print Email",
      fontDefault: "Default"
    },

    // Common
    common: {
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      update: "Update",
      close: "Close",
      download: "Download",
      upload: "Upload",
      search: "Search",
      filter: "Filter",
      all: "All",
      yes: "Yes",
      no: "No",
      sending: "Sending...",
      more: "more",
      confirm: "Confirm",
      back: "Back",
      next: "Next",
      previous: "Previous",
      copied: "Copied",
      error: "Error",
      success: "Success",
      loadFailed: "Failed to load",
      saveFailed: "Failed to save",
      deleteFailed: "Failed to delete",
      photoAlt: "Photo"
    },

    // Cookies
    cookies: {
      title: "Cookie Settings",
      description: "We use cookies for website usage analytics. Your data is only collected with your consent. Learn more in our",
      privacyLink: "Privacy Policy",
      accept: "Accept",
      decline: "Decline"
    },

    // Analytics
    analytics: {
      title: "Analytics",
      description: "Revenue, orders and user data at a glance",
      totalRevenue: "Total Revenue",
      paidOrders: "Paid Orders",
      totalUsers: "Users",
      nonBuyers: "Non-buyers",
      nonBuyersSub: "Parents with no paid order",
      totalPhotos: "Photos",
      revenueOverTime: "Revenue Over Time",
      ordersOverTime: "Orders Over Time",
      revenueBreakdown: "Revenue Breakdown",
      revenue: "Revenue",
      orders: "Orders",
      digital: "Digital",
      prints: "Prints",
      bundles: "Bundles",
      userRoles: "User Roles",
      topPhotos: "Top Selling Photos",
      purchases: "Purchases",
      recentOrders: "Recent Orders",
      orderId: "Order ID",
      customer: "Customer",
      amount: "Amount",
      date: "Date",
      pending: "pending",
      noData: "No data available yet",
      retentionTitle: "Retention Reminders",
      retentionDesc: "Send parents a reminder when their photos will be deleted in 10 days.",
      retentionExpiring: "Expiring soon",
      retentionOrders: "Orders",
      retentionUsers: "Users",
      retentionSendButton: "Send Reminders",
      retentionSending: "Sending...",
      retentionEmailsSent: "emails sent",
      retentionNoneAffected: "No photos are expiring soon right now.",
      nudgeTitle: "Purchase Nudge for Non-Buyers",
      nudgeDesc: "Remind registered parents with no order that their child's photos will be deleted soon.",
      nudgeOutstanding: "Outstanding",
      nudgeAlreadyReminded: "Already reminded",
      nudgeEligibleTotal: "Total eligible",
      nudgeDiagnostics: "{photos} photos in the target window (age {min}–{max} days · retention {retention} days). If 0: no photos in that band, or every affected parent has already paid / been nudged.",
      nudgeDaysBeforeLabel: "Days before deletion:",
      nudgeSendButton: "Send Nudge",
      nudgeSending: "Sending...",
      nudgeQueued: "emails queued",
      nudgeNoneOutstanding: "No outstanding parents to remind right now.",
      buyerBehaviorTitle: "Buyer Behavior",
      buyerBehaviorDesc: "Share of paid orders by product type",
      bundleBuyersLabel: "Bundle Buyers",
      printBuyersLabel: "Print Buyers",
      digitalOnlyBuyersLabel: "Digital Only",
      alacarteDigitalLabel: "Photos bought individually",
      alacarteDigitalSub: "Digital photos outside any bundle",
      reminderStatsTitle: "Cart Recovery",
      parentEngagementTitle: "Parent Engagement",
      parentEngagementDesc: "How many parents are buying photos, and for how many of their children.",
      purchaseRate: "Purchase rate",
      parentsLowercase: "parents",
      ordersPerParent: "Avg orders / parent",
      ordersPerParentSub: "Across all parents",
      ordersPerActiveParent: "Avg orders / buyer",
      ordersPerActiveParentSub: "Parents who ordered ≥1",
      childrenPerActiveParent: "Avg children / buyer",
      childrenPerActiveParentSub: "Distinct kids per purchasing parent",
      reminderStatsDesc: "How many reminder emails converted into real purchases (14-day window)",
      remindersSent: "Reminders Sent",
      remindersRecovered: "Carts Recovered",
      recoveryRate: "Recovery Rate",
      recoveredRevenue: "Recovered Revenue",
      openCarts: "Open Carts",
      role_admin: "Admin",
      role_teacher: "Teacher",
      role_parent: "Parent",
      periodLabel: "Period",
      schoolLabel: "School",
      classLabel: "Class",
      allSchools: "All schools",
      allClasses: "All classes",
      period_all: "All time",
      period_month: "This month",
      period_3months: "Last 3 months",
      period_6months: "Last 6 months",
      period_year: "This year",
      period_last_year: "Last year"
    },

    // Abandoned carts
    abandonedCarts: {
      title: "Abandoned Carts",
      description: "Users who left items in their cart without checking out.",
      olderThan: "Older than",
      h1: "1 hour",
      h6: "6 hours",
      h24: "24 hours",
      h72: "3 days",
      h168: "7 days",
      empty: "No abandoned carts",
      emptyDesc: "All users have completed their purchases.",
      items: "items",
      total: "Total",
      sendReminder: "Send Reminder",
      reminderSent: "Reminder sent",
      reminded: "Reminded",
      minutesAgo: "{n} min ago",
      hoursAgo: "{n} h ago",
      daysAgo: "{n} days ago"
    },

    // About
    about: {
      title: "About Me",
      noBio: "No description available yet."
    },

    // Contact form
    contact: {
      help: "Need help?",
      title: "Contact",
      description: "Send us a message. We usually reply within 24 hours.",
      category: "Category",
      cat_general: "General",
      cat_order: "Order",
      cat_missing_photo: "Missing photo",
      cat_payment: "Payment",
      cat_technical: "Technical issue",
      cat_other: "Other",
      subject: "Subject",
      subjectPlaceholder: "Short and to the point",
      message: "Message",
      messagePlaceholder: "Describe your question...",
      send: "Send",
      cancel: "Cancel",
      successToast: "Message sent! We'll be in touch.",
      errorToast: "Failed to send",
      rateLimitToast: "Too many messages. Please try again later.",
      respondNote: "We'll reply to your email:"
    }
  }
};
